import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatTabChangeEvent } from '@angular/material/tabs';

interface AdminTab {
    label: string;
    link: string;
}

@Component({
    selector: 'app-admin-layout',
    templateUrl: './admin-layout.component.html',
    standalone: false,
})
export class AdminLayoutComponent {
    tabs: AdminTab[] = [
        { label: 'ImportFromExternalSystem', link: 'importfromexternalsystem' },
    ];

    constructor(private router: Router) {}

    onTabChanged(event: MatTabChangeEvent): void {
        this.router.navigate(['/admin', this.tabs[event.index].link]);
    }
}
